import { Auth } from "aws-amplify";
import { ReactNode, useEffect, useState } from "react";
import { TenantContext } from "./TenantContext";

interface TenantProviderProps {
  children: ReactNode;
}

const TenantProvider = ({ children }: TenantProviderProps) => {
  const [tenant, setTenant] = useState<{
    tenantKey: string;
    makerFeaturesEnabled: boolean;
  } | null>(null);

  useEffect(() => {
    const fetchTenant = async () => {
      const user = await Auth.currentAuthenticatedUser();
      const idToken = user.signInUserSession.idToken.payload;
      const tenantKey = idToken.active_tenant;
      const makerFeaturesEnabled = idToken.is_maker_tenant === "true";

      setTenant({
        tenantKey,
        makerFeaturesEnabled
      });
    };

    fetchTenant();
  }, []);

  if (!tenant) {
    return null;
  }

  return (
    <TenantContext.Provider value={tenant}>{children}</TenantContext.Provider>
  );
};
export default TenantProvider;
